var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"文件","close-on-click-modal":false,"visible":_vm.dialogVisible,"width":"1250px","center":"","append-to-body":"","before-close":_vm.beforeClose},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.close}},[_c('div',{staticClass:"wpsCont"},[_c('iframe',{attrs:{"src":_vm.url}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70af39fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/office/wps.vue
// module id = null
// module chunks = 